define([
  'jquery'
], function($) {
    $.fn.drags = function(opt) {

        opt = $.extend({handle:"",cursor:"move"}, opt);

        if(opt.handle === "") {
            var $el = this;
        } else {
            var $el = this.find(opt.handle);
        }

        return $el.css('cursor', opt.cursor).on("mousedown.drags", function(e) {
            $(this).trigger('dragstart');
            if(opt.handle === "") {
                var $drag = $(this).addClass('draggable');
            } else {
                var $drag = $(this).addClass('active-handle').parent().addClass('draggable');
            }
            var z_idx = $drag.css('z-index'),
                drg_h = $drag.outerHeight(),
                drg_w = $drag.outerWidth(),
                pos_y = $drag.offset().top + drg_h - e.pageY,
                pos_x = $drag.offset().left + drg_w - e.pageX;
            $drag.css('z-index', 10000001).parents().on("mousemove.drags", function(e) {
                var top = e.pageY + pos_y - drg_h;
                var left = e.pageX + pos_x - drg_w;

                $('.draggable').trigger('dragmove', {
                    top: top,
                    left: left
                });
                $('.draggable').offset({
                    top: top,
                    left: left
                }).on("mouseup", function() {
                    $(this).removeClass('draggable').css('z-index', z_idx);
                });
            });
            e.preventDefault(); // disable selection
        }).on("mouseup.drags", function() {
            if(opt.handle === "") {
                var $drag = $(this).removeClass('draggable');
            } else {
                var $drag = $(this).removeClass('active-handle').parent().removeClass('draggable');
            }

            $drag.parents().unbind('mousemove.drags');

            $(this).trigger('dragend');
        });

    }
});
